var Variants = /* @__PURE__ */ ((Variants2) => {
  Variants2["COMPACT"] = "compact";
  Variants2["INFORMATIVE"] = "informative";
  return Variants2;
})(Variants || {});
const CA_BC = "cabc";
const COMPONENT_NAME = "ProductTile";
const INVALID_PROPS_ERROR = `${COMPONENT_NAME}-error: Missing required parameter SiteType of BusinessType`;
const currencyCodes = {
  "en-ca": "CAD",
  "en-us": "USD",
  "fr-ca": "CAD"
};
var productActionsVariant = /* @__PURE__ */ ((productActionsVariant2) => {
  productActionsVariant2["SignInButton"] = "SignInButton";
  productActionsVariant2["SelectOptions"] = "SelectOptions";
  productActionsVariant2["QuantitySelector"] = "QuantitySelector";
  productActionsVariant2["SeeDetails"] = "SeeDetails";
  productActionsVariant2["OutOfStock"] = "OutOfStock";
  return productActionsVariant2;
})(productActionsVariant || {});
var BadgeType = /* @__PURE__ */ ((BadgeType2) => {
  BadgeType2["CostcoGrocery"] = "Costco-Grocery";
  BadgeType2["TwoDayDelivery"] = "2-Day Delivery";
  return BadgeType2;
})(BadgeType || {});
export {
  BadgeType,
  CA_BC,
  COMPONENT_NAME,
  INVALID_PROPS_ERROR,
  Variants,
  currencyCodes,
  productActionsVariant
};
